// import React from 'react'
// import ReactDOM from 'react-dom/client'
// import { BrowserRouter } from 'react-router-dom'
// import { Toaster } from 'react-hot-toast'
// import App from './App'  // Fixed import
// import './index.css'

// ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <Toaster position="top-right" />
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// )

// frontend/src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Set global error handler
window.onerror = function (message, source, lineno, colno, error) {
  console.error('Global error:', { message, source, lineno, colno, error });

  // Send to error tracking service (e.g., Sentry)
  if (window.Sentry) {
    window.Sentry.captureException(error);
  }

  return false;
};

// Set unhandled promise rejection handler
window.onunhandledrejection = function (event) {
  console.error('Unhandled promise rejection:', event.reason);

  // Send to error tracking service
  if (window.Sentry) {
    window.Sentry.captureException(event.reason);
  }

  event.preventDefault();
};

// Initialize app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA (optional)
// Service worker registration removed to prevent 404 errors
// if ('serviceWorker' in navigator && import.meta.env.PROD) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js').catch(() => {});
//   });
// }